import { render, staticRenderFns } from "./FileUploader.vue?vue&type=template&id=d96dd86e&scoped=true&"
import script from "./FileUploader.vue?vue&type=script&lang=js&"
export * from "./FileUploader.vue?vue&type=script&lang=js&"
import style0 from "./FileUploader.vue?vue&type=style&index=0&id=d96dd86e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../CommunityWebPortal/_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96dd86e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d96dd86e')) {
      api.createRecord('d96dd86e', component.options)
    } else {
      api.reload('d96dd86e', component.options)
    }
    module.hot.accept("./FileUploader.vue?vue&type=template&id=d96dd86e&scoped=true&", function () {
      api.rerender('d96dd86e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueCommon/common-components/src/components/shared/FileUploader.vue"
export default component.exports